import useCountry from './useCountry'
import useAsiaPacific from './useAsiaPacific'
import {
  arabicCountryCodes,
  chineseCountries,
  europeCountries,
  latinAmericaCountries,
  northAmericaCountries,
  subSaharanAfricaCountryCodes,
} from './areaCountryCodes'

export default function useAreaDefinition() {
  const country = useCountry()
  const isLatinAmerica = latinAmericaCountries.includes(country)
  const { isAsiaPacific } = useAsiaPacific()
  const isEurope = europeCountries.includes(country)
  const isNorthAmerica = northAmericaCountries.includes(country)
  const isEuropeOrNorthAmerica = isEurope || isNorthAmerica
  const isRussia = country === 'RU'
  const isChineseCountry = chineseCountries.includes(country)
  const isArabicCountry = arabicCountryCodes.includes(country)
  const isSubSaharanAfrica = subSaharanAfricaCountryCodes.includes(country)

  return {
    isArabicCountry,
    isAsiaPacific,
    isChineseCountry,
    isEurope,
    isEuropeOrNorthAmerica,
    isLatinAmerica,
    isNorthAmerica,
    isRussia,
    isSubSaharanAfrica,
  }
}
